import { loader } from 'graphql.macro'
import { intercomConnection } from '../../intercomConnection'

export default async function updateTicketFlagged ({ dataLoaders, variables }) {
  const schema = loader('./updateTicketFlagged.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  intercomConnection.trackEvent('ticket_flag_changed', { flag: variables.flag })
  return response.updateTicketFlag
}
